'use strict'

/**
 * Project easytitle24 app
 * Created by hielo on 2018-05-29
 *
 * This plugin exposes easytitle24 services through a Vue.js plugin
 */

import {security} from 'CommonApp/security/security-service'
import {projectService} from './project-service'
import {productService} from './product-service'
import {paymentService} from './payment-service'
import {orderService} from './order-service'
import {contactService} from './contact-service'
import {helpService} from 'Common/services/help-service'
import {formService} from './form-service'
import {geoService} from './geo-service'

function e24Services (Vue) {
	if (e24Services.installed) {
		return
	}

	Vue.e24 = {
		security: security(Vue.http),
		projectService: projectService(Vue.http),
		productService: productService(Vue.http),
		paymentService: paymentService(Vue.http),
		orderService: orderService(Vue.http),
		contactService: contactService(Vue.http),
		helpService: helpService(Vue.http),
		formService: formService(Vue.http),
		geoService: geoService(Vue.http)
	}
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(e24Services)
}

export default e24Services



// WEBPACK FOOTER //
// ./src/common/e24-services/index.js